import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedServicesComponent } from './shared-services.component';
const routes: Routes = [
  {
    path: '',
    component: SharedServicesComponent,
    title: 'shared-services'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedServicesRoutingModule { }
